import React from 'react';

const StepBadge = ({ seq, isFirst, requestDetails }) => {
    const rawDetail = isFirst
        ? requestDetails[0]
        : requestDetails.find(d => d.seq === seq);
    const isComplete = rawDetail?.is_complete == 1;
    return (
        <span className={`detail-stop-badge ${isComplete ? 'detail-stop-badge--delivered' : 'detail-stop-badge--indelivery'}`}>
            <i className={isComplete ? 'mdi mdi-map-marker-check' : 'ri-feedback-fill'} />
            {isComplete ? 'Delivered' : 'In delivery'}
        </span>
    );
};

export default StepBadge;